import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from 'app/core';
import { TrackingPageModule as TrackingPageComponentsModule } from 'app/core/tracking-page';
import { FontPickerModule, FONT_PICKER_CONFIG } from 'ngx-font-picker';
import { environment } from '../../environments/environment';
import {
  CONTAINERS,
  TrackingPageNumbersComponent,
  TrackingPageRootComponent
} from './containers';
import { GUARDS } from './guards';
import { TrackingPageStoreModule } from './store/tracking-page';
import { TrackingPageNumbersStoreModule } from './store/tracking-page-numbers';
import { TrackingPageRoutingModule } from './tracking-page-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { StorageService } from 'app/core';

@NgModule({
  imports: [
    CommonModule,
    TrackingPageRoutingModule,
    ReactiveFormsModule,
    CoreDirectivesModule,
    TrackingPageComponentsModule,
    TrackingPageStoreModule,
    TrackingPageNumbersStoreModule,
    FontPickerModule,
    HttpClientModule,
    TranslateModule
  ],
  declarations: [CONTAINERS],
  exports: [TrackingPageRootComponent, TrackingPageNumbersComponent],
  providers: [
    GUARDS,
    {
      provide: FONT_PICKER_CONFIG,
      useValue: { apiKey: environment.googleFontsKey }
    },
    StorageService
  ]
})
export class TrackingPageModule {}
